import UseResponsiveBreakpoints from "../../../views/hooks/UseResponsiveBreakpoints.js";
import MobileSearchBar from "./MobileSearchBar.js";
import DesktopSearchBar from "./DesktopSearchBar.js";
export default function ResponsiveSearchBar(props) {
  return UseResponsiveBreakpoints({
    big: DesktopSearchBar,
    small: MobileSearchBar
  }, props);
}